<title>{{ serviceStatusPage.htmlTitle }}</title>
<app-banner [banner]="serviceStatusPage.banner" [isCommonBanner]="true" [isDefaultPageBanner]="false"></app-banner>
<ng-template [ngIf]="isMaintenanceBannerDisabled">
  <div class="container-fluid minHeight">
    <div class="container mt-30 service-status-container">
      <div *ngIf="serviceStatusPage.note">
        <div [ngClass]="serviceStatusPage.note.noteClass" class="mt-10 mb-10" role="alert">
          <i [ngClass]="serviceStatusPage.note.iconClass || ''"></i>
          <span class="pl-2" [innerHTML]="serviceStatusPage.note.body || '' | mdToHtml"></span>
        </div>
      </div>
      <div id="errorpn-VoucherRedeem" *ngIf="serviceStatusError">
        <div id="errDet" class="err-VoucherRedeem">
          {{ serviceStatusError }}
        </div>
      </div>
      <div id="ssbanner"></div>
      <div *ngFor="let service of servicesArray">
        <div class="row pb-30">
          <div class="col-md-12">
            <div class="panel panel-info">
              <div
                class="panel-heading"
                [ngClass]="{
                  'bordertop-green': service.averageFfailureRate >= 0 && service.averageFfailureRate <= 20,
                  'border-top-amber': service.averageFfailureRate > 20 && service.averageFfailureRate <= 80,
                  'border-top-red': service.averageFfailureRate > 80
                }"
              >
                <div class="row">
                  <div class="col-md-9 pl-3 pt-2">
                    <h4><i class="fa fa-plug"></i> 17.2 {{ service.serviceName }}</h4>
                  </div>
                  <div
                    class="col-md-2"
                    [ngClass]="{
                      'left-top-border-green': service.averageFfailureRate >= 0 && service.averageFfailureRate <= 20,
                      'left-border-amber': service.averageFfailureRate > 20 && service.averageFfailureRate <= 80,
                      'left-border-red': service.averageFfailureRate > 80
                    }"
                  >
                    <h4 class="mb-0 ps-1" *ngIf="service.averageFfailureRate >= 0 && service.averageFfailureRate <= 20"><i class="fa fa-grin-alt svgrn"></i> OK</h4>
                    <h4 class="mb-0 ps-1" *ngIf="service.averageFfailureRate > 20 && service.averageFfailureRate <= 80"><i class="fa fa-meh face-amber"></i> DEGRADED</h4>
                    <h4 class="mb-0 ps-1" *ngIf="service.averageFfailureRate > 80"><i class="fa fa-surprise face-red"></i> Error</h4>
                    <span class="smll" *ngIf="service.averageFfailureRate >= 0 && service.averageFfailureRate <= 20">No errors reported </span>
                    <span class="smll" *ngIf="service.averageFfailureRate > 20 && service.averageFfailureRate <= 80"> {{ service.roundedAverageFailureRate }} % Errors reported </span>
                    <span class="smll" *ngIf="service.averageFfailureRate > 80"> Complete failure </span>
                  </div>
                </div>
              </div>

              <div class="panel-body panelMinHt">
                <div id="svc" class="row">
                  <ng-container *ngFor="let status of service.statusArray">
                    <div
                      class="col-sm-4"
                      [ngClass]="{
                        svgrnb: status.failureRate <= 20,
                        svorlb: status.failureRate > 20 && status.failureRate <= 80,
                        svredb: status.failureRate > 80,
                        svgryb: status.OKtext === 'Unknown Status'
                      }"
                    >
                      <h3 class="mb-0 mt-0" [ngClass]="{ gry: status.OKtext === 'Unknown Status' }">{{ status.serviceName }}</h3>
                      <span class="ps-1" [ngClass]="{ gry: status.OKtext === 'Unknown Status' }">
                        <b *ngIf="status.failureRate === 0 && status.OKtext !== 'Unknown Status'">OK </b> {{ status.OKtext }}</span
                      >
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Chart Area Started -->
      <div class="row ms-3">
        <ng-container *ngIf="ischartLoaded">
          <div class="panel panel-info panel-body panelMinHt row">
            <div class="col-11">
              <h3>Live API Status</h3>
              <div #chartDiv id="initial_chart_live"></div>
            </div>
          </div>
          <div class="panel panel-info panel-body panelMinHt row">
            <div class="col-11">
              <h3>Prelive API Status</h3>
              <div #chartDiv id="initial_chart_prelive"></div>
            </div>
          </div>

          <div class="panel panel-info panel-body panelMinHt row">
            <div class="col-11">
              <h3>Beta API Status</h3>
              <div #chartDiv id="initial_chart_beta"></div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</ng-template>

<div *ngIf="serviceStatusPage.card" class="container pageNotFound mb-50">
  <div class="error-container">
    <h3>{{ serviceStatusPage.card.shortBody }}</h3>
    <p>{{ serviceStatusPage.card.body }}</p>
  </div>
</div>
